/*
 * PanamaJack — Enlaces externos a target="_blank" + rel="noreferrer noopener".
 * Extraído de theme.js durante el rebase a Showcase 10.2.0 (iso-funcional).
 * Vanilla JS, sin dependencias. Carga con defer desde layout/theme.liquid.
 */
(function () {
  function markExternalLinks() {
    var links = document.links;
    for (var i = 0, len = links.length; i < len; i++) {
      if (links[i].hostname !== window.location.hostname) {
        links[i].target = "_blank";
        links[i].rel = "noreferrer noopener";
      }
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", markExternalLinks);
  } else {
    markExternalLinks();
  }
})();
